import React from 'react';

function Importance() {
  return (
    <div>
      <h2 className='font-bold text-gray-700 mt-4 text-xl md:text-2xl lg:text-3xl'>
        Importance
      </h2>
      <p className='text-gray-900 md:text-lg lg:text-xl'>
        A pronoun is a word that is used instead of a noun or a noun phrase.
        It's good practice to ask which pronouns a person uses. Respecting
        someone's self-identification means using the gender pronouns with which
        they identify with.
      </p>
    </div>
  );
}

export default Importance;
